import makeValidationSchema from './LicensePlatesMakeValidationSchema'
import { components, useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import ConveyanceMasterKeys from 'src/constants/locale/key/ConveyanceMaster'
import Grid from '@material-ui/core/Grid'
import { useFormContext } from "react-hook-form";
import { NaStateCodeAutoCompleteField, NaAceStateCodeAutoCompleteField } from 'src/components/na'
import ConveyanceMasterTranslationText from './context/ConveyanceMasterTranslationText'

const {
  form: {
    field: { CngTextField, CngCodeMasterAutocompleteField }
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  licensePlateNo: "",
  countryofRegistration: "CA",
  state: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, shouldHideMap }) {
  const { setValue, watch } = useFormContext();
  // const { translate } = useTranslation(Namespace.CONVEYANCE_MASTER)
  // const translatedTextsObject = makeTranslatedTextsObject()
  const conveyanceMasterTranslationText = ConveyanceMasterTranslationText()
  const countryofRegistration = watch('countryofRegistration')

  // function makeTranslatedTextsObject() {
  //   const licensePlateNo = translate(
  //     Namespace.CONVEYANCE_MASTER,
  //     ConveyanceMasterKeys.LicensePlates.LICENSE_PLATE_NO
  //   )
  //   const countryofRegistration = translate(
  //     Namespace.CONVEYANCE_MASTER,
  //     ConveyanceMasterKeys.LicensePlates.COUNTRYOF_REGISTRATION
  //   )
  //   const state = translate(
  //     Namespace.CONVEYANCE_MASTER,
  //     ConveyanceMasterKeys.LicensePlates.STATE
  //   )

  //   return { licensePlateNo, countryofRegistration, state }
  // }

  return (
    <Grid container spacing={2}>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.licensePlateNo}>
        <CngTextField
          name='licensePlateNo'
          label={conveyanceMasterTranslationText.licensePlateNo}
          isRequired
          disabled={disabled}
          onBlur={(e) =>
            setValue('licensePlateNo', e.target.value.toUpperCase())
          }
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.countryofRegistration}>
        <CngCodeMasterAutocompleteField
          name='countryofRegistration'
          label={conveyanceMasterTranslationText.countryofRegistration}
          isRequired
          disabled={disabled}
          onChange={() => setValue('state', '', { shouldValidate: true })}
          codeType='ACIHW_CONVEYANCE_COUNTRY'
        />
      </CngGridItem>
      {countryofRegistration == 'MX' && (
        <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.state}>
          <NaAceStateCodeAutoCompleteField
            name='state'
            label={conveyanceMasterTranslationText.state}
            disabled={disabled}
            countryCode={countryofRegistration}
            key={countryofRegistration}
          />
        </CngGridItem>
      )}
      {(countryofRegistration == 'US' || countryofRegistration == 'CA') && (
        <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.state}>
          <NaStateCodeAutoCompleteField
            name='state'
            label={conveyanceMasterTranslationText.state}
            isRequired
            disabled={disabled}
            countryCode={countryofRegistration}
            key={countryofRegistration}
          />
        </CngGridItem>
      )}
    </Grid>
  )
}

const LicensePlatesFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default LicensePlatesFormProperties
